const lipFiller = {
  hero: {
    titlePrefix: "Προηγμένες",
    titleAccent: "Θεραπείες Ενίσχυσης",
    titleSuffix: "Χειλιών",
    description:
      "Αναδείξτε τη φυσική σας ομορφιά με τις ασφαλείς και αποτελεσματικές θεραπείες αύξησης όγκου χειλιών, σχεδιασμένες για να σας χαρίσουν τα τέλεια, γεμάτα χείλη που πάντα επιθυμούσατε.",
    ctas: {
      primary: "Κλείστε Ραντεβού",
      secondary: "Μάθετε Περισσότερα",
    },
    imageAlt: "Γυναίκα με γεμάτα, φυσικά χείλη μετά από θεραπεία filler",
    callout: {
      title: "Φυσικά Αποτελέσματα",
      body: "Τα fillers χειλιών μας ενισχύουν τη φυσική σας ομορφιά χωρίς υπερβολές",
    },
  },
  benefits: {
    headingPrefix: "Οφέλη από τα",
    headingAccent: "Lip Fillers",
    intro:
      "Ανακαλύψτε πώς τα premium fillers μας μπορούν να βελτιώσουν την αισθητική του προσώπου σας και να ενισχύσουν την αυτοπεποίθησή σας.",
    items: [
      {
        title: "Φυσική Ενίσχυση",
        description:
          "Τα fillers μας ενισχύουν φυσικά το σχήμα των χειλιών σας, χωρίς να δίνουν τεχνητή όψη.",
      },
      {
        title: "Άμεσα Αποτελέσματα",
        description:
          "Δείτε ορατή βελτίωση αμέσως μετά τη θεραπεία με ελάχιστο χρόνο ανάρρωσης.",
      },
      {
        title: "Εξατομικευμένος Όγκος",
        description:
          "Μπορούμε να προσθέσουμε όσο όγκο επιθυμείτε για να πετύχετε την ιδανική σας εμφάνιση.",
      },
      {
        title: "Βελτίωση Σχήματος Χειλιών",
        description:
          "Διορθώστε την ασυμμετρία και ορίστε με ακρίβεια τα όρια των χειλιών για πιο ισορροπημένο αποτέλεσμα.",
      },
      {
        title: "Μείωση Λεπτών Ρυτίδων",
        description:
          "Εξομαλύνετε τις κάθετες γραμμές των χειλιών και τις ρυτίδες γύρω από το στόμα.",
      },
      {
        title: "Προσωρινή Διάρκεια",
        description:
          "Απολαύστε την ευελιξία μιας μη μόνιμης λύσης που διαρκεί συνήθως 6-12 μήνες.",
      },
    ],
  },
  process: {
    headingPrefix: "Η",
    headingAccent: "Διαδικασία Αυξητική",
    headingSuffix: "Χειλιών",
    intro:
      "Οι premium θεραπείες αύξησης όγκου χειλιών ακολουθούν μια προσεκτική διαδικασία που διασφαλίζει ασφάλεια, άνεση και φυσικά, όμορφα αποτελέσματα.",
    steps: [
      {
        title: "Συμβουλευτικό Ραντεβού",
        description:
          "Συναντηθείτε με τον ειδικό μας για να συζητήσετε τους στόχους και τις προσδοκίες σας σχετικά με την ενίσχυση των χειλιών.",
      },
      {
        title: "Σχεδιασμός Θεραπείας",
        description:
          "Δημιουργούμε ένα εξατομικευμένο πλάνο θεραπείας, προσαρμοσμένο στα χαρακτηριστικά του προσώπου σας και στο επιθυμητό αποτέλεσμα.",
      },
      {
        title: "Προετοιμασία",
        description:
          "Εφαρμόζεται τοπική αναισθητική κρέμα για να διασφαλιστεί η άνεσή σας κατά τη διάρκεια της διαδικασίας.",
      },
      {
        title: "Έγχυση",
        description:
          "Ο ειδικός μας πραγματοποιεί προσεκτικά την έγχυση του υαλουρονικού για φυσικό όγκο και καλοσχηματισμένα χείλη.",
      },
      {
        title: "Αποτελέσματα",
        description:
          "Απολαύστε άμεσα ορατά αποτελέσματα που θα συνεχίσουν να διαμορφώνονται όμορφα τις επόμενες ημέρες.",
      },
    ],
  },
  faq: {
    headingPrefix: "Συχνές",
    headingAccent: "Ερωτήσεις",
    intro: "Βρείτε απαντήσεις σε κοινές ερωτήσεις σχετικά με τις θεραπείες lip filler.",
    items: [
      {
        question: "Πόσο διαρκούν τα lip fillers;",
        answer:
          "Τα lip fillers διαρκούν συνήθως από 6 έως 12 μήνες, ανάλογα με τον τύπο του υλικού και τον μεταβολισμό σας. Με τον χρόνο, ο οργανισμός απορροφά φυσικά το υλικό, και απαιτούνται επαναληπτικές συνεδρίες για να διατηρηθεί το επιθυμητό αποτέλεσμα.",
      },
      {
        question: "Είναι επώδυνη η διαδικασία του lip filler;",
        answer:
          "Πριν από τη θεραπεία εφαρμόζεται αναισθητική κρέμα για να μειωθεί η ενόχληση. Οι περισσότεροι ασθενείς αισθάνονται μόνο ήπια πίεση ή ένα ελαφρύ τσίμπημα κατά την ένεση. Πολλά fillers περιέχουν επίσης λιδοκαΐνη, τοπικό αναισθητικό, για μεγαλύτερη άνεση.",
      },
      {
        question: "Πότε θα δω αποτελέσματα από τα lip fillers;",
        answer:
          "Θα παρατηρήσετε άμεσα αύξηση όγκου μετά τη θεραπεία, αν και μπορεί να υπάρχει προσωρινό πρήξιμο. Τα τελικά αποτελέσματα φαίνονται μόλις υποχωρήσει το πρήξιμο, συνήθως μέσα σε 1-2 εβδομάδες.",
      },
      {
        question: "Ποιος είναι ο χρόνος ανάρρωσης;",
        answer:
          "Οι περισσότεροι ασθενείς επιστρέφουν στις καθημερινές τους δραστηριότητες αμέσως. Μπορεί να εμφανιστεί ελαφρύ πρήξιμο, μελανιές ή ευαισθησία για 2-3 ημέρες. Συνιστούμε αποφυγή έντονης άσκησης για 24-48 ώρες μετά τη θεραπεία.",
      },
      {
        question: "Μπορώ να αναιρέσω το αποτέλεσμα αν δεν μου αρέσει;",
        answer:
          "Ναι, τα fillers με βάση το υαλουρονικό οξύ (που χρησιμοποιούμε) μπορούν να διαλυθούν με ένα ένζυμο που λέγεται υαλουρονιδάση. Αυτή η δυνατότητα αντιστροφής είναι ένας από τους λόγους που τα fillers αυτά είναι τόσο δημοφιλή.",
      },
      {
        question: "Ποιοι δεν είναι κατάλληλοι υποψήφιοι για lip fillers;",
        answer:
          "Άτομα που είναι έγκυες, θηλάζουν, έχουν συγκεκριμένα αυτοάνοσα νοσήματα, ενεργό έρπη ή αλλεργία στα συστατικά των fillers, δεν πρέπει να υποβληθούν σε αυξητική χειλιών. Κατά τη διάρκεια της συμβουλευτικής συνεδρίας θα αξιολογήσουμε το ιατρικό ιστορικό σας για να διασφαλίσουμε την ασφάλεια της θεραπείας.",
      },
    ],
  },
};

export default lipFiller;

